<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab label="فروش قرارداد">
            <IndexReport></IndexReport>
          </vs-tab>
          <vs-tab
            label="محصولات در انتظار شارژ"
            v-if="IndexMomentaryInventoryPermission"
          >
            <IndexMomentaryInventory></IndexMomentaryInventory>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import SecurityService from "../../../auth/SecurityService.js";
import IndexReport from "../ReportsOrder/Contract/Index.vue";
import IndexMomentaryInventory from "./MomentaryInventory/Index.vue";

import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_Reports_Index",

  components: {
    IndexReport,
    IndexMomentaryInventory
  },
  data() {
    return {
      IndexMomentaryInventoryPermission : true
    }
  },
  created() {
    var permissionList = SecurityService.permissionList.split(",");
    if (!permissionList.includes("GetAllSaleAgentQuotaByPageInfo")) {
      this.IndexMomentaryInventoryPermission = false;
    }
  }
};
</script>
